import { TooltipWithTitle, TooltipWithTitleProps } from '@salecycle/experimental/TooltipWithTitle';
import { SvgIcon } from '@salecycle/ui-component-library';
import { useTheme } from 'styled-components';

export type InfoTooltipProps = Omit<TooltipWithTitleProps, 'children'> & {
  displayInline?: boolean;
};

export const InfoTooltip = ({ displayInline, ...props }: InfoTooltipProps) => {
  const theme = useTheme();
  return (
    <div style={displayInline ? { display: 'inline-block' } : undefined}>
      <TooltipWithTitle {...props}>
        <SvgIcon name="circle-question" size="16" color={theme.designToken.primary700} style={{ cursor: 'pointer' }} />
      </TooltipWithTitle>
    </div>
  );
};
